import { IStoreRankState } from 'v3/data/store/Rank/RankStore/types';

export const storeRankInitialState: IStoreRankState = {
  list: {
    count: 0,
    items: [],
  },
  filter: {
    name: '',
    page: 0,
    rowsPerPage: 5,
  },
};
